const BASE_CONST = 'GET_EXPORTED_FILE';
export const GET_EXPORTED_FILE = `${BASE_CONST}`;
export const GET_EXPORTED_FILE_TEMPLATE = `${BASE_CONST}_TEMPLATE`;
export const GET_EXPORTED_CUSTOMER_IMPORT_TEMPLATE = `${BASE_CONST}_CUSTOMER_IMPORT_TEMPLATE`;
export const GET_EXPORTED_CUSTOMER_EXPORT_TEMPLATE = `${BASE_CONST}_CUSTOMER_EXPORT_TEMPLATE`;
